import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { GetUsageRecordSummaryResponse, ListUsageRecordsRequest, ListUsageRecordsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminUsageRecordApi = createApi({
    reducerPath: "adminUsageRecordApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listUsageRecords: builder.query<ListUsageRecordsResponse, ListUsageRecordsRequest>({
            query: body => ({
                url: `usageRecord/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        }),
        getSevenDayUsageRecordSummary: builder.query<GetUsageRecordSummaryResponse, void>({
            query: () => "usageRecord/summary/7-day"
        }),
        getThirtyDayUsageRecordSummary: builder.query<GetUsageRecordSummaryResponse, void>({
            query: () => "usageRecord/summary/30-day"
        })
    })
});

export const {
    useGetSevenDayUsageRecordSummaryQuery,
    useGetThirtyDayUsageRecordSummaryQuery,
    useListUsageRecordsQuery
} = adminUsageRecordApi;
